var lib_core = require("lib-core");
var colors = require("../../colors/colors.js");

var OriginView = function(root, editor2DView, editor2DModel, originModel, layers, config){
    var self = this;
    this.root = root;
    this.editor2DView  = editor2DView;
    this.editor2DModel  = editor2DModel;
    this.originModel = originModel;
    this.cameraModel = originModel.cameraModel;
    this.config = config;

    //init the svg groups
    this.initLayers(layers);

    //add the observers
    this.initObservers();
};

module.exports = OriginView;

OriginView.prototype.initLayers = function(layers){
    var self = this;
    this.drawingLayer = this.editor2DView.getLayers().get(layers.drawinglayer).svgGroup;
    this.controlLayer = this.editor2DView.getLayers().get(layers.controllayer).svgGroup;
    this.gridGroup = this.editor2DView.svg.group(this.drawingLayer);
    this.originGroup = this.editor2DView.svg.group(this.drawingLayer);
    this.controlGroup = this.editor2DView.svg.group(this.controlLayer);
};

OriginView.prototype.initObservers = function(){
    var self = this;

    if (!this.config.cantClick) {
        $(this.controlGroup).mousedown(function(event){
            return self.onMouseDown(event);
        });
    }

    this.originModel.lines.onChange('linesChanged', function(){
        if (self.originModel.grid_show()) self.editor2DView.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    },10);

    this.originModel.grid_show.onChange('gridShowChanged', function(){
        self.editor2DView.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    },10);

    this.originModel.grid_unit.onChange('gridShowChanged', function(){
        // this gets changed from the inspector, and we want to see immediate change
        // without refocusing
        self.draw();
    },10);

    this.originModel.grid_value.onChange('gridShowChanged', function(){
        // this gets changed from the inspector, and we want to see immediate change
        // without refocusing
        self.draw();
    },10);
};

OriginView.prototype.draw = function () {
    if(this.config.noView) return;
    var self = this;

    // fix for safari - (works for all also)
    // remove scale from this inner group by scaling this group by the reciprocol of the
    // grandparent's scale .. assummes the grndparent svg group scale is set to viewS()
    // cannot remove scale from getLines() because snapSet depends on it as well
    var mult = self.cameraModel.viewS();
    self.editor2DView.svg.change(self.drawingLayer, {
        'transform': 'scale(' + (1.0/mult) + ','+ (1.0/mult) +')'
    });
    self.editor2DView.svg.change(self.controlLayer, {
        'transform': 'scale(' + (1.0/mult) + ','+ (1.0/mult) +')'
    });

    if (self.originModel.grid_show()) {
        self.drawGrid();
    } else {
        $(this.gridGroup).empty();
    }

    if(self.originModel.origin_show()) {
        this.drawOriginSymbol();
    } else {
        $(this.originGroup).empty();
    }
};

OriginView.prototype.drawOriginSymbol = function() {
    var self = this;

    $(self.originGroup).empty();

    var size = self.originModel.gridOriginSize;
    var radius = 1.5 * size / 10;
    var mult = self.cameraModel.viewS();
    var thickness = 1.5 / mult; // should not scale with zoom level

    $(this.controlGroup).empty();
    var positionX = self.originModel.position().getX();
    var positionY = self.originModel.position().getY();

    var attrs = {
        'fill'    : this.originModel.gridOriginFill,
        'shape-rendering':      'geometricPrecision',
        'stroke-width': thickness,
        'stroke': "none",
        'fill-rule': "evenodd"
    };

    self.makeRect({ x1: positionX+radius, y1: positionY, x2: positionX+size, y2: positionY}, false, attrs);
    self.makeRect({ x1: positionX-size, y1: positionY, x2: positionX-radius, y2: positionY}, false, attrs);
    self.makeRect({ x1: positionX, y1: positionY+radius, x2: positionX, y2: positionY+size}, true, attrs);
    self.makeRect({ x1: positionX, y1: positionY-size, x2: positionX, y2: positionY-radius}, true, attrs);

    self.editor2DView.svg.circle(self.originGroup,
        positionX * mult, positionY * mult, radius * mult, {
        'stroke': this.originModel.gridOriginFill,
        'strokeWidth' : thickness * mult,
        'fill': 'none'
    });

    // this one for clicking on
    self.circle = self.editor2DView.svg.circle(self.controlGroup,
        positionX * mult, positionY * mult, radius * mult, {
        'stroke': 'green',
        'strokeWidth' : thickness * mult,
        'fill': 'green',
        'opacity': 0.0
    });
};

// custom rendering values specific to the browser
OriginView.prototype.gridLineAttrs = function(sector) {
    var self = this;
    var mult = self.cameraModel.viewS();

    return {
        'fill'    : (sector ? this.originModel.gridSectorFill : this.originModel.gridFill),
        'shape-rendering':      'geometricPrecision',
        'stroke-width': mult,
        'stroke': "none",
        'fill-rule': "evenodd"
    };
};

OriginView.prototype.makeRect = function(line, vert, attrs) {
    var self = this;
    var mult = self.cameraModel.viewS();

    // since the scale was applied before these lines were calculated, and now we removed that scale
    // the lines are huge and need to be scaled down again
    self.editor2DView.svg.rect(
        self.gridGroup, (line.x1) * mult-0.5, (line.y1) * mult-0.5,
        (vert ? 1.0 : Math.abs(line.x2-line.x1) * mult),
        (vert ? Math.abs(line.y2-line.y1) * mult : 1.0),
        attrs
    );
};

OriginView.prototype.drawGrid = function() {
    var self = this;

    $(self.gridGroup).empty();

    var lines = this.originModel.lines();

    var sector = null;
    lines.ver.forEach(function (line) {
        sector = ((line.index % 10) == 0);
        if(!sector) { self.makeRect(line, true, self.gridLineAttrs(sector)); }
    });
    lines.hor.forEach(function (line) {
        sector = ((line.index % 10) == 0);
        if(!sector) { self.makeRect(line, false, self.gridLineAttrs(sector)); }
    });

    // need sector lines on top of other lines
    lines.ver.forEach(function (line) {
        sector = ((line.index % 10) == 0);
        if(sector) { self.makeRect(line, true, self.gridLineAttrs(sector)); }
    });
    lines.hor.forEach(function (line) {
        sector = ((line.index % 10) == 0);
        if(sector) { self.makeRect(line, false, self.gridLineAttrs(sector)); }
    });

    // cleanup
    lines = null;
};

/**
 * @param   {Object}    event
 * @return  {boolean}
 * @this    {Origin}
 */
OriginView.prototype.onMouseDown = function(event)
{
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN, this.originModel.interactionModel(), event)
        .data( 'mouseCoord', this.editor2DView.relativeMouseCoord(event) );
    return this.editor2DView.stateMachine.handle(cEvent);
};

OriginView.prototype.setSelected = function () {
};

OriginView.prototype.toggleGrid = function() {
    if(this.originModel.grid_show()){
        this.originModel.grid_show(false);
    } else {
        this.originModel.grid_show(true);
    }
};
